import { produce as n } from "immer";
import { create as e } from "zustand";
import { devtools as r } from "zustand/middleware";
const s = e()(
  r(
    (i) => ({
      notifications: {},
      actions: {
        addNotification: ({ mapId: o, notification: t }) => {
          i(
            n((a) => {
              a.notifications[o] = t;
            }),
            !1,
            `addNotification - ${o}`
          );
        }
      }
    }),
    {
      name: "PLMapboxNotificationStore",
      enabled: !!(window && window.__REDUX_DEVTOOLS_EXTENSION__)
    }
  )
);
export {
  s as usePLMapboxNotificationStore
};
//# sourceMappingURL=index.es35.js.map
